import WizardShell from "./WizardShell";
import VoiceTextarea from "@/components/VoiceTextarea";

const REFLECT_QUESTIONS = [
  {
    id: "frustrates",
    label: "What frustrates them?",
    placeholder: "The friction in their day, said in their words if you can.",
    rows: 3,
  },
  {
    id: "doing_instead",
    label: "What are they doing instead?",
    placeholder: "Workarounds, hacks, the spreadsheet they secretly love.",
    rows: 3,
  },
  {
    id: "feel_but_not_say",
    label: "What might they feel but not say?",
    placeholder: "The quiet emotion under the surface — embarrassment, fear, hope.",
    rows: 3,
  },
];

export default function WitnessStep({ value, onChange, onBack, onNext }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const canContinue = value.who_for.trim().length > 3;

  return (
    <WizardShell
      pillLabel="Step 2 · Witness"
      pillColor="#f4b847"
      headline="Who is this really for?"
      aiOpening={
        "Not 'everyone'. Not a market segment. A real person you can picture.\n\nWhen you see them clearly, the next decisions get easier."
      }
      testid="witness-step"
      footer={
        <>
          <button
            type="button"
            className="weave-btn-outline"
            onClick={onBack}
            data-testid="witness-back-btn"
          >
            ← Back
          </button>
          <button
            type="button"
            className="weave-btn-primary"
            onClick={onNext}
            disabled={!canContinue}
            data-testid="witness-next-btn"
          >
            Continue to Align
          </button>
        </>
      }
    >
      <div>
        <label
          className="block text-sm text-slate-500 mb-2"
          htmlFor="witness-who-for"
        >
          Describe the person — role, context, life stage, anything specific
        </label>
        <VoiceTextarea
          rows={4}
          placeholder="They are…"
          value={value.who_for}
          onChange={(v) => set("who_for", v)}
          ariaLabel="Describe the person — role, context, life stage"
          testid="witness-who-for-input"
          micTestid="witness-who-for-mic"
        />
      </div>

      <div className="weave-divider" />

      <p className="text-sm uppercase tracking-[0.18em] text-slate-400 mb-4">
        Step into their world
      </p>

      <div className="space-y-6">
        {REFLECT_QUESTIONS.map((q) => (
          <div key={q.id}>
            <label className="block text-base text-slate-700 mb-2">
              {q.label}
            </label>
            <VoiceTextarea
              rows={q.rows}
              placeholder={q.placeholder}
              value={value[q.id]}
              onChange={(v) => set(q.id, v)}
              ariaLabel={q.label}
              testid={`witness-${q.id}-input`}
              micTestid={`witness-${q.id}-mic`}
            />
          </div>
        ))}
      </div>
    </WizardShell>
  );
}
